module.exports = __webpack_public_path__ + "img/finance_persetujuan.a5f4f6e6.svg";